// DEFAULT ROOT PATH
export const DEFAULT_PATH = '/';

// REST API URL (Collect Feedback)
export const COLLECT_FEEDBACK_API = "https://m6bduqqo8h.execute-api.ap-southeast-1.amazonaws.com/prod/messages"

// Login API URL
export const LOGIN_API = "https://auth.api.celcomdigi.tech/login/profile"

// Symphony Summit Email Registration Check API URL
export const EMAIL_CHECK_API = process.env.REACT_APP_EMAIL_CHECK_API ||
  "https://rest-tds.api.prod.celcomdigi.tech"

// TDS Onboarding Dashboard URL for registration
export const ONBOARDING_URL = process.env.REACT_APP_ONBOARDING_URL ||
  "https://forms.office.com/pages/responsepage.aspx?id=dokEvxBxh06W88Z0SQi4vke8ZGYXkLhHmxUMf9L6HSpURU5NMFVVVDc3WENUUFVVTFRWTDlFV0ZIUC4u&route=shorturl"
